import { render, staticRenderFns } from "./PasswordRecoverView.vue?vue&type=template&id=3434cfa7&"
import script from "./PasswordRecoverView.vue?vue&type=script&lang=js&"
export * from "./PasswordRecoverView.vue?vue&type=script&lang=js&"
import style0 from "./PasswordRecoverView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports